import { SpaceObjectType, Tle } from "@graphic/types";
import { useEffect, useState } from "react";

import { API_GPS } from "@/modules/api/keyFactory";
import { createSatelliteData } from "@graphic/utils";
import axios from "axios";

export const useObjectData = (satIds: number[]) => {
  const [objectData, setObjectData] = useState<SpaceObjectType[]>([]);

  useEffect(() => {
    if (satIds.length === 0) return;
    fetchSatelliteData(satIds);
  }, [satIds]);

  const fetchSatelliteData = async (satIds: number[]) => {
    const tles: Tle[] = [];

    const promises = satIds.map(async satId => {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${API_GPS}/${satId}`,
        {
          params: {
            epoch: new Date().toISOString()
          }
        }
      );
      if (!response.data.data) return;
      const { name, firstLine, secondLine } = response.data.data;
      return { name, firstLine, secondLine } as Tle;
    });

    const results = await Promise.all(promises);
    const filteredResults = results.filter(
      (result): result is Tle => result !== undefined
    );
    tles.push(...filteredResults);

    const data = createSatelliteData(tles);
    setObjectData(data);
  };

  return {
    objectData
  };
};
